<app-in-app-page>
  <app-header [title]="'Send faxes'"></app-header>

  <div class="send" *ngIf="!showProcessingStep">
    <div class="send__header">
      <app-stepper [steps]="STEPS" [currentStep]="currentStep"></app-stepper>
    </div>

    <div class="send-page__content">
      <div [hidden]="!isActiveStep(0)">
        <app-fax-recipient-info-form
          [defaultData]="defaultRecipientData"
          (submit)="setRecipientInfo($event)"
        ></app-fax-recipient-info-form>
      </div>

      <div [hidden]="!isActiveStep(1)">
        <app-attachment
          (navigateBack)="navigateToPreviousPage()"
          (submit)="generateFaxPdf($event)"
        ></app-attachment>
      </div>

      <app-preview-fax
        *ngIf="isActiveStep(2)"
        [pdf]="faxPdf"
        (onPageSubmit)="navigateToNextPage()"
        (navigateBack)="navigateToPreviousPage()"
      ></app-preview-fax>

      <app-send-fax-finish
        *ngIf="isActiveStep(3)"
        (onFormSubmit)="sendFax($event)"
        (navigateBack)="navigateToPreviousPage()"
      ></app-send-fax-finish>

      <app-retry-send-fax
        *ngIf="showRetryStep"
        [errorMessage]="errorMessage"
        (retry)="retrySendFax()"
      ></app-retry-send-fax>
    </div>
  </div>

  <div class="send" *ngIf="showProcessingStep">
    <div class="send-page__actions">
      <button (click)="sendNewFax()" class="btn_primary btn_md">Send new fax</button>
    </div>

    <div class="send-status">
      <h2 class="section-header">Message</h2>

      <div class="send-status__row" *ngIf="isSentFaxPending">
        <img src="assets/img/icons/round-icons/clock-go-green.svg" alt="waiting" class="send-status__icon" />
        <span class="send-status__text">Waiting for processing...</span>
      </div>

      <div class="send-status__row" *ngIf="isSentFaxSuccessful">
        <img src="assets/icons/success.svg" alt="success" class="send-status__icon" />
        <span class="send-status__text">Fax sent successfully</span>
      </div>

      <div class="send-status__row" *ngIf="isSentFaxFailed">
        <img src="assets/icons/error.svg" alt="error" class="send-status__icon" />
        <span class="send-status__text">Fax failed to send</span>
      </div>
    </div>
  </div>
</app-in-app-page>

<app-expired-subscription-error-modal
  (close)="redirectToSubscription()"
></app-expired-subscription-error-modal>
